export default __webpack_public_path__ + "static/Magni-Pi1-95cc4e43e21512b85001cf0853dc3d74.mp4";